module.exports = __webpack_public_path__ + "media/slot-game/steak-f45a6bbb.svg";